import * as types from '../constants/ActionTypes'

const interactions = (state = [], action) => {
    switch (action.type) {
      case 'INTERACTIONS_NUMBER':
      return {
          type: "INTERACTIONS_NUMBER",
          interactions: action.interactions
        }
      default:
        return state
    }
  }
  
  export default interactions
  